import * as React from 'react';
import styles from './Experience.module.css'
import Title from '../helper/Title';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import SecurityIcon from '@mui/icons-material/Security';
import TerminalIcon from '@mui/icons-material/Terminal';
import AddHomeWorkIcon from '@mui/icons-material/AddHomeWork';
import Typography from '@mui/material/Typography';

export default function CustomizedTimeline() {
  return (
    <section className={styles.section} id="experience">
      <Title className={styles.sectiontitle} title='my' subTitle='experience'/>
    <Timeline position="alternate">
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          align="right"
          variant="body2"
          color="text.primary"
        >
          August 2014 – June 2022

        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector sx={{ backgroundColor: 'primary.main' }} />
          <TimelineDot color="primary">
            <MilitaryTechIcon/>
          </TimelineDot>
          <TimelineConnector sx={{ backgroundColor: 'primary.main' }} />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
          <Typography variant="h6" component="span">
          Gendarmerie General Command
          </Typography>
          <Typography color="text.primary">Gendarmerie Petty Officer</Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          variant="body2"
          color="text.primary"
        >
          February 2021 – June 2022

        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector sx={{ backgroundColor: 'primary.main' }} />
          <TimelineDot color="primary">
            <SecurityIcon />
          </TimelineDot>
          <TimelineConnector sx={{ backgroundColor: 'primary.main' }} />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
          <Typography variant="h6" component="span">
          Gendarmerie General Command
          </Typography>
          <Typography color="text.primary">Cyber Security Specialist</Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
      <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          align="right"
          variant="body2"
          color="text.primary"
        >
          October 2022 – September 2023


        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector sx={{ backgroundColor: 'primary.main' }} />
          <TimelineDot color="primary">
            <TerminalIcon />
          </TimelineDot>
          <TimelineConnector sx={{ backgroundColor: 'primary.main' }} />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
          <Typography variant="h6" component="span">
          Neos Software and Academy
          </Typography>
          <Typography color="text.primary">Internship and training</Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
      <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          align="right"
          variant="body2"
          color="text.primary"
        >
          September 2023 – 


        </TimelineOppositeContent>

        <TimelineSeparator>
          <TimelineConnector sx={{ backgroundColor: 'primary.main' }} />
          <TimelineDot color="success">
            <AddHomeWorkIcon />
          </TimelineDot>
          <TimelineConnector sx={{ backgroundColor: 'primary.main' }} />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
          <Typography variant="h6" component="span">
          Freelance Work
          </Typography>
          <Typography color="text.primary">I keep improving myself</Typography>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
    </section>
  );
}